import { Navigate, Route, Routes } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import GuestPage from './pages/GuestPage'
import StaffLoginPage from './pages/StaffLoginPage'
import FohPage from './pages/FohPage'
import BohPage from './pages/BohPage'
import ManagePage from './pages/ManagePage'
import StudioPage from './pages/StudioPage'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/r/:slug/t/:tableNumber" element={<GuestPage />} />
      <Route path="/login" element={<StaffLoginPage />} />
      <Route path="/app/foh" element={<FohPage />} />
      <Route path="/app/boh" element={<BohPage />} />
      <Route path="/app/manage" element={<ManagePage />} />
      <Route path="/app/studio" element={<StudioPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
